import styled from 'styled-components';

import OutputText from '@ey/canvascoreservices/OutputText';

export default styled(OutputText)`
	border-bottom: 0.1rem solid transparent;
	transition: all 0.1s ease-in-out;
	cursor: pointer;
	&:hover {
		border-bottom: 0.1rem solid currentColor;
	}
`